import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { MatriculaProgramaModel, ResidenteMatriculadoDetailsModel, TipoComissaoEnum } from '@shared/models/backend'
import { BehaviorSubject, of } from 'rxjs'
import { catchError, take } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class VisualizarResidenteService {
  constructor(private http: HttpClient) {}

  private residenteMartriculado$ = new BehaviorSubject<ResidenteMatriculadoDetailsModel | null>(null)

  getResidenteMatriculado() {
    return this.residenteMartriculado$.asObservable()
  }

  setResidenteMatriculado(residente: ResidenteMatriculadoDetailsModel) {
    this.residenteMartriculado$.next(residente)
  }

  refreshResidente(programaId: string, matriculaId: number) {
    this.getResidenteMatriculadoDetails(programaId, matriculaId).subscribe((residente) =>
      this.residenteMartriculado$.next(residente)
    )
  }

  getResidenteMatriculadoDetails(programaId: string, matriculaId: number) {
    return this.http
      .get<ResidenteMatriculadoDetailsModel>(`/api/programas/${programaId}/residentes/${matriculaId}`)
      .pipe(catchError((_) => of(null)))
      .pipe(take(1))
  }

  getMatriculasResidente(residenteId: number, tipoComissao: TipoComissaoEnum) {
    let params = new HttpParams()
    params = params.append('query', residenteId.toString())
    params = params.append('tipoComissao', tipoComissao.toString())
    return this.http
      .get<MatriculaProgramaModel[]>('/api/residentes/matriculas', { params })
      .pipe(take(1))
  }

  getNewerMatriculaPrograma(matriculaId: number) {
    let params = new HttpParams()
    params = params.append('query', matriculaId.toString())

    return this.http
      .get<MatriculaProgramaModel>('/api/residentes/matriculaRecente', { params })
      .pipe(take(1))
  }
}
